import { render, staticRenderFns } from "./InputSigarusPlantilla.vue?vue&type=template&id=3cf0aefc"
import script from "./InputSigarusPlantilla.vue?vue&type=script&lang=js"
export * from "./InputSigarusPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports